import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../constants/Styles";

export const SVGAppContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const SVGApp = styled.div<{
  whiteBackground?: boolean;
  frameless?: boolean;
  grabbable?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
  border: ${({ frameless }) => (frameless ? "none" : `1px solid ${COLORS.secondaryLight}`)};
  cursor: ${({ grabbable }) => (grabbable ? "auto" : "grab")};
    ${({ whiteBackground }) => whiteBackground && `background: white;`}}
    
`;

export const SVGContainer = styled.div<{ $hidden?: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  visibility: ${({ $hidden }) => ($hidden ? "hidden" : "inherit")};
`;

export const RootSVG = styled.svg`
  width: 100%;
  height: 100%;
`;

export const Title = styled.div`
  color: ${COLORS.secondary};
  position: absolute;
  left: 0.5rem;
  top: 0.25rem;
  font-size: ${FONT_SIZE.size16};
  font-weight: ${FONT_WEIGHT.weight400};
  font-variant-numeric: tabular-nums;
`;

export const Tools = styled.div`
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  display: flex;
  transform-origin: bottom right;
  gap: 0.5rem;
`;

export const SVGViewerPill = styled.div<{
  viewOnly?: boolean;
}>`
  cursor: ${({ viewOnly }) => (viewOnly ? "default" : "pointer")};
  border-radius: 1rem;
  background: rgba(80, 80, 80, 80.75);
  padding: 0.25rem 0.5rem 0.25rem 0.5rem;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
  gap: 2px;
  height: 24px;
  font-variant-numeric: tabular-nums;

  &:hover {
    background: rgba(90, 90, 90, 0.75);
  }
`;
